import { LoginState } from '../../store/state/login.state';
import { loginReducer } from '../../store/reducers/login.reducers';

export interface AppState{
    login: LoginState
}

export const appReducer = {
    login: loginReducer
}